import React from "react";

const TYPE_LABEL = { "Full-time": "Full-time", "Part-time": "Part-time", "Temporary/Seasonal": "Temporary / Seasonal", "Contract/Project-based": "Contract / Project", "Apprentice/Trainee": "Apprentice / Trainee" };
const UNIT_LABEL = { "Per month": "Monthly", "Per day": "Daily", "Per hour": "Hourly", "Per project": "Per project", Negotiable: "Negotiable" };
const unitOf = (j) => (j.salary_from == null && j.unit !== "Negotiable" ? "" : j.unit || "");

export const isFresherOk = (j) => j.experience === "fresher" || j.experience === "any";

export const withinKm = (j, km) => j.same_pincode || (j.distance_km != null && j.distance_km <= km);

export function filterJobs(items, f, savedIds) {
  return items.filter((j) => (!f.type || j.type === f.type) && (!f.unit || unitOf(j) === f.unit) && (!f.fresher || isFresherOk(j))
    && (!f.saved || savedIds?.has(j.id)) && (!f.km || withinKm(j, f.km)));
}

const RADII = [5, 10, 25];

const selCls = "border border-slate-200 rounded-full bg-white text-xs font-semibold text-slate-700 px-3 py-2 min-h-[40px] outline-none focus:border-emerald-500 max-w-full";

export default function JobFilters({ items, value, onChange, savedCount = null, hasPin = false, savedIds = null, onKm = null }) {
  const setKm = (km) => (onKm ? onKm(km) : onChange({ ...value, km }));
  const kmCount = (km) => filterJobs(items, { ...value, km }, savedIds).length;
  const types = [...new Set(items.map((j) => j.type).filter(Boolean))];
  const units = [...new Set(items.map(unitOf).filter(Boolean))];
  const fresherCount = items.filter(isFresherOk).length;
  const active = Boolean(value.type || value.unit || value.fresher || value.saved || value.km);
  return (
    <div className="mb-6 flex flex-wrap items-center gap-2" role="group" aria-label="Job filters" data-testid="job-filters">
      <select aria-label="Job type" value={value.type} onChange={(e) => onChange({ ...value, type: e.target.value })} className={selCls} data-testid="job-filter-type">
        <option value="">All job types</option>
        {types.map((t) => <option key={t} value={t}>{TYPE_LABEL[t] || t}</option>)}
      </select>
      <select aria-label="Salary type" value={value.unit} onChange={(e) => onChange({ ...value, unit: e.target.value })} className={selCls} data-testid="job-filter-salary">
        <option value="">All salary types</option>
        {units.map((u) => <option key={u} value={u}>{UNIT_LABEL[u] || u}</option>)}
      </select>
      <button type="button" aria-pressed={value.fresher} disabled={!fresherCount && !value.fresher} onClick={() => onChange({ ...value, fresher: !value.fresher })}
        className={`rounded-full border px-3 py-2 min-h-[40px] text-xs font-semibold transition-colors disabled:opacity-50 ${value.fresher ? "bg-emerald-700 border-emerald-700 text-white" : "bg-white border-slate-200 text-slate-700 hover:border-emerald-500"}`} data-testid="job-filter-fresher">
        {value.fresher ? "✓ " : ""}Fresher chalega ({fresherCount})
      </button>
      <div className="inline-flex items-center rounded-full border border-slate-200 bg-white p-0.5" role="radiogroup" aria-label="Distance" data-testid="job-filter-radius" title={hasPin ? "" : "Pehle header me PIN chunein"}>
        {[0, ...RADII].map((km) => (
          <button key={km} type="button" role="radio" aria-checked={(value.km || 0) === km} disabled={!hasPin && km !== 0}
            onClick={() => setKm(km)}
            className={`rounded-full px-2.5 py-1.5 min-h-[36px] text-xs font-semibold transition-colors disabled:opacity-40 ${(value.km || 0) === km ? "bg-emerald-700 text-white" : "text-slate-700 hover:text-emerald-700"}`}
            data-testid={`job-filter-radius-${km || "any"}`}>
            {km ? `${km} km` : "Any km"}{hasPin && <span className="ml-1 opacity-70" data-testid={`job-filter-radius-count-${km || "any"}`}>({kmCount(km)})</span>}
          </button>
        ))}
      </div>
      {savedCount !== null && (
        <button type="button" aria-pressed={!!value.saved} onClick={() => onChange({ ...value, saved: !value.saved })}
          className={`rounded-full border px-3 py-2 min-h-[40px] text-xs font-semibold transition-colors ${value.saved ? "bg-rose-500 border-rose-500 text-white" : "bg-white border-slate-200 text-slate-700 hover:border-rose-400"}`} data-testid="job-filter-saved">
          ♥ Saved jobs ({savedCount})
        </button>
      )}
      {active && <button type="button" onClick={() => { onChange({ type: "", unit: "", fresher: false, saved: false, km: 0 }); onKm?.(0); }} className="text-xs font-semibold text-slate-500 hover:text-rose-600 px-2 min-h-[40px]" data-testid="job-filter-clear">Clear</button>}
    </div>
  );
}
